import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { formatDate, fromISO8601_DATE } from "../../../utils/iso8601";
import type { LibraryTemplate } from "../library/types";
import type { DiscoverTemplate } from "../types";

interface MomentCardContentProps {
  template: DiscoverTemplate;
  subheadingGetter?: (t: DiscoverTemplate) => string | null;
}

export const MomentContent: FC<MomentCardContentProps> = ({ template, subheadingGetter }) => {
  return (
    <Stack gap={1}>
      <Typography variant="body2" fontWeight={600}>
        {template.title}
      </Typography>
      {subheadingGetter && (
        <Typography variant="body2" color="neutral.500" fontWeight={500}>
          {subheadingGetter(template)}
        </Typography>
      )}
      {template.type === "moment" && (
        <Typography variant="body2" color="primary.light" fontWeight={500}>
          {getDateString(template)}
        </Typography>
      )}
    </Stack>
  );
};

function getDateString(template: LibraryTemplate): string {
  if (template.date === null) return template.recommendations.send_time;

  const startDate = fromISO8601_DATE(template.date);

  const formatted = formatDate(startDate, undefined, { month: "short" });

  if (template.end_date !== null) {
    const endDate = fromISO8601_DATE(template.end_date);
    return startDate.getTime() === endDate.getTime()
      ? formatted
      : `${formatted} - ${formatDate(endDate, undefined, { month: "short" })}`;
  }

  return formatted;
}
